// Tolerante Suche: Groß-/Kleinschreibung, Umlaute, ß, Satzzeichen (Kommas, Ausrufezeichen, Bindestriche, ...)
// und mehrfache Leerzeichen spielen keine Rolle. "Ich der Herr" findet "Ich, der Herr! Aller Herren Herr bin ich".

const APOSTROPHE = new Set(["'", '’', '‘', 'ʼ', '`', '´']);

// Normalisiert einen Text und merkt sich zu jedem Zeichen die Position im Original (für die Hervorhebung).
// umlauteAusschreiben: ä -> ae statt ä -> a (damit auch "schoepfung" für "Schöpfung" gefunden wird).
function normalisiere(text, umlauteAusschreiben) {
  let ergebnis = '';
  const positionen = [];
  const hinzufuegen = (zeichen, position) => {
    ergebnis += zeichen;
    for (let i = 0; i < zeichen.length; i += 1) positionen.push(position);
  };

  Array.from(String(text ?? '')).reduce((position, zeichen) => {
    const klein = zeichen.toLowerCase();
    let ersatz;
    if (klein === 'ß') ersatz = 'ss';
    else if (umlauteAusschreiben && 'äöü'.includes(klein)) ersatz = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue' }[klein];
    else ersatz = klein.normalize('NFD').replace(/[̀-ͯ]/g, '');

    if (APOSTROPHE.has(klein)) {
      // wenn's -> wenns: Apostroph wird einfach weggelassen
    } else if (/^[a-z0-9]+$/.test(ersatz)) {
      hinzufuegen(ersatz, position);
    } else if (ergebnis && !ergebnis.endsWith(' ')) {
      hinzufuegen(' ', position); // alle anderen Zeichen trennen Wörter
    }
    return position + zeichen.length;
  }, 0);

  return { text: ergebnis.trimEnd(), positionen };
}

const VARIANTEN = [false, true];

// Zerlegt den Namen in Teile; Teile mit treffer = true sind die gefundenen Stellen des Suchbegriffs.
export function zerlegeNachTreffern(name, suchbegriff) {
  const original = String(name ?? '');
  for (const ausschreiben of VARIANTEN) {
    const begriff = normalisiere(suchbegriff, ausschreiben).text;
    if (!begriff) return [{ text: original, treffer: false }];
    const norm = normalisiere(original, ausschreiben);
    const bereiche = [];
    let start = norm.text.indexOf(begriff);
    while (start !== -1) {
      const ende = start + begriff.length - 1;
      bereiche.push([norm.positionen[start], norm.positionen[ende] + 1]);
      start = norm.text.indexOf(begriff, start + begriff.length);
    }
    if (bereiche.length) {
      const teile = [];
      let aktuell = 0;
      bereiche.forEach(([von, bis]) => {
        if (von < aktuell) return;
        if (von > aktuell) teile.push({ text: original.slice(aktuell, von), treffer: false });
        teile.push({ text: original.slice(von, bis), treffer: true });
        aktuell = bis;
      });
      if (aktuell < original.length) teile.push({ text: original.slice(aktuell), treffer: false });
      return teile;
    }
  }
  return [{ text: original, treffer: false }];
}

function enthaelt(text, suchbegriff) {
  return VARIANTEN.some((ausschreiben) => {
    const begriff = normalisiere(suchbegriff, ausschreiben).text;
    return !begriff || normalisiere(text, ausschreiben).text.includes(begriff);
  });
}

// Passt das Lied (Titel oder Nummer, z. B. "w126" oder "126") zum Suchbegriff? Ohne Suchbegriff passt jedes Lied.
export function passtZurSuche(lied, suchbegriff, nummer) {
  if (!normalisiere(suchbegriff, false).text) return true;
  if (enthaelt(lied.name, suchbegriff)) return true;
  const ohneLeerzeichen = (text) => normalisiere(text, false).text.replace(/ /g, '');
  const begriff = ohneLeerzeichen(suchbegriff);
  return Boolean(begriff) && ohneLeerzeichen(nummer).includes(begriff);
}
